(() => {
	if (window.croJdgmReviews) return;
	window.croJdgmReviews = true;

	const ROOT_SELECTOR = '#judgeme_product_reviews, .jdgm-review-widget.jdgm-widget-revamp';

	const parseWidgetData = (root) => {
		const id = root.getAttribute('data-product-id') || root.getAttribute('data-id');
		const live = window.jdgm?.data?.reviewWidget?.[id];
		if (live) return live;

		const host = root.closest('.shopify-block') || root.parentElement;
		const script = host?.querySelector('.jdgm-review-widget-data');
		if (!script) return null;

		const match = script.textContent.match(/jdgm\.data\.reviewWidget\[[^\]]+\]\s*=\s*(\{[\s\S]*\});?/);
		if (!match?.[1]) return null;

		try {
			return JSON.parse(match[1]);
		} catch {
			return null;
		}
	};

	const starString = (rating) => {
		const value = Number.parseFloat(rating) || 0;
		const full = Math.floor(value);
		const half = value - full >= 0.4 ? 1 : 0;
		const empty = Math.max(0, 5 - full - half);
		return `${'★'.repeat(full)}${half ? '½' : ''}${'☆'.repeat(empty)}`;
	};

	const renderHistogram = (data) => {
		const bars = (data?.histogram || []).slice().sort((a, b) => b.rating - a.rating);
		if (!bars.length) return '';

		return bars
			.map((row) => {
				const pct = Number(row.percentage) || 0;
				return `<div class="cro-jdgm-summary__row">
					<span class="cro-jdgm-summary__label">${row.rating}</span>
					<span class="cro-jdgm-summary__track"><span class="cro-jdgm-summary__fill" style="width:${pct}%"></span></span>
					<span class="cro-jdgm-summary__pct">${pct}%</span>
				</div>`;
			})
			.join('');
	};

	const ensureSummary = (root, data) => {
		if (root.querySelector('[data-cro-jdgm-summary]')) return;

		const header = root.querySelector('.jm-review-widget__header');
		if (!header) return;

		const rating = data?.average_rating || root.getAttribute('data-shop-average-rating') || '';
		const count = data?.number_of_reviews || root.getAttribute('data-shop-review-count') || '';
		const summary = document.createElement('div');
		summary.className = 'cro-jdgm-summary';
		summary.setAttribute('data-cro-jdgm-summary', '');
		summary.innerHTML = `
			<div class="cro-jdgm-summary__score">
				<p class="cro-jdgm-summary__value">${rating ? Number.parseFloat(rating).toFixed(1) : ''}</p>
				<div class="cro-jdgm-summary__stars" aria-hidden="true">${starString(rating)}</div>
				<p class="cro-jdgm-summary__count">${count ? `Based on ${count} reviews` : ''}</p>
			</div>
			<div class="cro-jdgm-summary__bars">${renderHistogram(data)}</div>
		`;
		header.insertAdjacentElement('afterend', summary);
	};

	const moveFilters = (root) => {
		const filters = root.querySelector('.jm-review-widget-minimal-header__filters');
		const summary = root.querySelector('[data-cro-jdgm-summary]');
		if (!filters || !summary || filters.dataset.croMoved === 'true') return;
		filters.dataset.croMoved = 'true';
		summary.insertAdjacentElement('afterend', filters);
	};

	const enhanceReviews = (root) => {
		root.querySelectorAll('.jm-review-item').forEach((item) => {
			const details = item.querySelector('.jm-reviewer-info__details');
			const content = item.querySelector('.jm-review-item__content');
			const reviewer = item.querySelector('.jm-reviewer-info');
			const stars = item.querySelector('.jm-star-rating');
			const body = item.querySelector('.jm-review-content');
			if (!details || !content) return;

			const clusters = [...details.querySelectorAll(':scope > .jm-cluster')];
			const nameRow = clusters[0];
			const dateText = clusters[1]?.querySelector('.jm-text');
			if (nameRow && dateText && !nameRow.contains(dateText)) {
				dateText.setAttribute('data-cro-jdgm-date', '');
				nameRow.appendChild(dateText);
			}

			if (reviewer && stars && reviewer.nextElementSibling !== stars) {
				content.appendChild(reviewer);
				content.appendChild(stars);
				if (body) content.appendChild(body);
			}

			const badge = item.querySelector('.jm-verified-buyer-badge');
			const badgeText = badge?.querySelector('.jm-verified-buyer-badge__text');
			if (badgeText && badgeText.textContent.trim() === 'Verified') {
				badgeText.textContent = 'Verified Purchase';
			}
			if (badge && body && badge.parentElement !== body) body.appendChild(badge);
		});
	};

	const enhance = (root) => {
		if (!root) return;
		const data = parseWidgetData(root);
		ensureSummary(root, data);
		moveFilters(root);
		enhanceReviews(root);
	};

	const scan = () => {
		document.querySelectorAll(ROOT_SELECTOR).forEach((root) => enhance(root));
	};

	scan();
	document.addEventListener('jdgm:done', scan);
	document.addEventListener('jdgm.done', scan);

	let timer = 0;
	const first = document.querySelector(ROOT_SELECTOR);
	if (first) {
		const observer = new MutationObserver(() => {
			window.clearTimeout(timer);
			timer = window.setTimeout(scan, 80);
		});
		observer.observe(first, { childList: true, subtree: true });
	}
})();
